import React, { useCallback, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import Header from "./Header";
import Footer from "./Footer";
import Dashboard from "./Dashboard";
import PageLayout from "../PageLayout";
import DashboardHero from "./DashboardHero";
import Brand from "../../api/Brand";
import EarningsOverview, { Overview } from "../../api/EarningsOverview";

const Home = () => {
    const [cookies] = useCookies(["uuid", "brand_id", "location_id"]);
    const { uuid, brand_id, location_id } = cookies;

    const [brand, setBrand] = useState<Brand | undefined>();
    const [logo, setLogo] = useState<string | null | undefined>();
    const [overview, setOverview] = useState<Overview | undefined>();
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        if (!uuid || !brand_id) return;
        Brand.info(uuid, brand_id)
            .then((res) => {
                setBrand(res);
                setLogo(res?.logo);
            })
            .catch(console.error);
    }, [uuid, brand_id]);

    // Single source of truth for the home's earnings figures. Today/week/month
    // are derived server-side in the location timezone.
    useEffect(() => {
        if (!uuid || !brand_id || !location_id) return;
        EarningsOverview.info(uuid, brand_id, location_id)
            .then(setOverview)
            .catch(console.error);
    }, [uuid, brand_id, location_id]);

    const handleScrollY = useCallback((y: number) => setScrollY(y), []);

    const setupSteps = brand?.setupSteps;
    const setupProgress = setupSteps
        ? {
              done: [
                  setupSteps.branding,
                  setupSteps.wallpaper,
                  setupSteps.services,
                  setupSteps.location,
                  setupSteps.profileInfo,
                  setupSteps.loyalty,
              ].filter(Boolean).length,
              total: 6,
          }
        : undefined;

    return (
        <>
            <Header brand={brand} logo={logo} scrollY={scrollY} />
            <PageLayout
                hero={
                    <DashboardHero
                        overview={overview}
                        setupProgress={setupProgress}
                    />
                }
                onScrollY={handleScrollY}
            >
                <Dashboard brand={brand} overview={overview} />
            </PageLayout>
            <Footer tab="home" />
        </>
    );
};

export default Home;
